// extracted by mini-css-extract-plugin
module.exports = {"root":"caption_root___tgpz"};